<template>
  <TypeAhead
    v-model="data"
    :srcImgLoading="srcImgLoading"
    :classes="classes"
    :placeholder="placeholder"
    :src="urlGetAutocomplete"
    :getResponse="getResponse"
    :selectFirst="selectFirst"
    :limit="parseInt(limit)"
    :queryParamName="queryParamName"
    :minChars="parseInt(minChars)"
    :delayTime="parseInt(delayTime)"
    :onHit="onHit"
    :highlighting="highlighting"
    :render="render"
    :fetch="fetch"
    :clean="cleanNucleoUrbano"
  ></TypeAhead>
</template>
<script>
import axios from "axios";
import TypeAhead from "../templatesComponents/VueSaxTypeAheadTemplate";

import { mapState, mapMutations } from "vuex";

// const DEFAULT_TOKEN = "b5abb242-39a3-4179-a6c3-8eaf4269ea85";

export default {
  components: {
    TypeAhead,
  },
  data() {
    return {
      data: "",
      access_token: process.env.VUE_APP_TOKEN_APIS,
      store_ubigeo: this.$store.getters.store_getUbigeo,
      urlGetAutocomplete: "",
      selectFirst: true,
      srcImgLoading: "@/assets/images/loading-two.gif",
      limit: 7,
      queryParamName: ":search",
      minChars: 2,
      delayTime: 0,
      placeholder: "Urbanizacion o nucleo urbano",
      classes: "typeahead searchNucleoUrbano",
    };
  },
  created() {
    this.urlGetAutocomplete = process.env.VUE_APP_URL_NUCLEO_URBANO;
  },
  mounted() {
    let app = this;
    if (app.checkLogin()) {
      const tokenData = JSON.parse(window.localStorage.getItem("geodir_Token"));
      app.access_token = tokenData.data.access_token;
      // app.urlGetAutocomplete = process.env.VUE_APP_URL_NUCLEO_URBANO + this.ubigeo+'/nucleo?access_token='+app.access_token+'&search=:search';

      app.urlGetAutocomplete =
        process.env.VUE_APP_SUBLOCALITIES +
        "&key=" +
        app.access_token +
        "&locality_id=" +
        this.ubigeo;
    }

    this.$store.watch(this.$store.getters.store_getUbigeo, (ubigeo) => {
      app.store_ubigeo = ubigeo;

      app.urlGetAutocomplete =
        process.env.VUE_APP_SUBLOCALITIES +
        "&key=" +
        app.access_token +
        "&locality_id=" +
        ubigeo;
      // app.urlGetAutocomplete = process.env.VUE_APP_URL_NUCLEO_URBANO + ubigeo+'/nucleo?access_token='+app.access_token+'&search=:search';
      /*if(!ubigeo){
          app.store_ubigeo=ubigeo; 
      }*/
    });

    this.$store.watch(this.$store.getters.isLoggedIn, (n) => {
      if (!n) {
        app.access_token = process.env.VUE_APP_TOKEN_APIS;
      }
    });
  },
  computed: {
    ...mapState(["map"]),
  },
  /*watch:{
    store_ubigeo(ubigeo){
      console.log('WATCH ::: COMPONENT UBIGEO');
      console.log('cambio ubigeo ' + ubigeo);
      this.urlGetAutocomplete = this.urlGetAutocomplete + ubigeo+'/ubigeo?access_token='+this.access_token+'&search=:search';
      console.log(this.urlGetAutocomplete);
    }
  },*/

  methods: {
    checkLogin() {
      return this.$store.state.isLoggedIn;
    },
    getResponse: function (response) {
      return response.data;
    },

    onHit: function (item, vue, index, event) {
      console.log('nucelo urbano');
      if (item) {
        event.preventDefault();

        let layerMarker = this.$store.getters.layerMarkerSearcher;
        //let polygonSearcher = this.$store.getters.layerPolygonSearcher;
console.log('marker');
        if (layerMarker) {
          this.map.removeLayer(layerMarker);
        }

        /*if (polygonSearcher) {
          this.map.removeLayer(polygonSearcher);
        }*/

        /*
        function styleUbigeo() {
          return {
            fillColor: "transparent",
            color: "transparent",
          };
        }
        
        var json = JSON.parse(item.bbox);
        let newResult = new L.GeoJSON(json, {
          style: styleUbigeo,
        });

        this.map.addLayer(newResult);
        this.map.flyToBounds(newResult.getBounds(), {
          maxZoom: 16,
        });
        */

        //this.$store.commit("SET_LAYER_MARKER", newResult);

        let nameNucleoUrbano = item.name;
        let tipoNucleoUrbano = item.pattern_abbr;

console.log('guardar valores');
console.log(nameNucleoUrbano);
console.log(tipoNucleoUrbano);
        this.$store.commit("SET_NU_DIRECTION", nameNucleoUrbano);
        this.$store.commit("SET_TIPO_NU_DIRECTION", tipoNucleoUrbano);

        // agregar poligono de nucleo urbano
        if(item.geojson){
          const parsedGeoJson = JSON.parse(item.geojson);
          var polygon = L.geoJSON(parsedGeoJson);
          
          this.map.fitBounds(polygon.getBounds());
        }
        
        //this.$store.commit("SET_GEOJSON_MARKER", polygon);

        vue.query = item.name;

        this.$emit("eventSelectNucleoUrbano");
      }
    },

    highlighting: function (item, vue) {
      let value = "";

      if (typeof item === "object") {
        value = item.name;
      } else {
        value = item;
      }
      return value
        .toString()
        .replace(vue.query.toUpperCase(), `<b>${vue.query.toUpperCase()}</b>`);
    },

    render: function (items, vue) {
      //let newItem = [vue.query, ...items];
      let newItem = [...items];
      return newItem;
    },

    fetch: function (url) {
      return axios.get(url);
    },

    cleanNucleoUrbano() {
      this.$emit("cleanNucleoUrbanoEmittion");
    },
  },
};
</script>
<style>
.searchNucleoUrbano {
  font-size: 14px;
}
</style>
